import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createOverview: {
		id: 'spa-apps-sidebar-core.multi-project-menu.overviews.create-overview',
		defaultMessage: 'Create an overview',
		description: 'Button that allows the user to create a new overview of projects.',
	},
	overviewsHeader: {
		id: 'spa-apps-sidebar-core.multi-project-menu.overviews.overviews-header',
		defaultMessage: 'Overviews',
		description: 'Title of the overviews section in the sidebar navigation.',
	},
	errorMessage: {
		id: 'spa-apps-sidebar-core.multi-project-menu.overviews.error-message',
		defaultMessage: "We couldn't load overviews",
		description:
			'Error message shown when the overviews could not be loaded in the side navigation.',
	},
	refreshPage: {
		id: 'spa-apps-sidebar-core.multi-project-menu.overviews.refresh-page',
		defaultMessage: 'Refresh page',
		description: 'Button to refresh the page in an attempt to solve the error.',
	},
});
